import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RichTextEditorModule } from '@flyfreely-portal-ui/rich-text-editor';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { AttachmentHandlerService } from 'libs/comments/src/lib/attachment-handler.service';
import { CommentComponent } from './comment/comment.component';
import { CommentsComponent } from './comments/comments.component';

@NgModule({
    imports: [CommonModule, SharedUiModule, RichTextEditorModule.forChild()],
    declarations: [CommentsComponent, CommentComponent],
    exports: [CommentsComponent, CommentComponent],
    providers: [AttachmentHandlerService]
})
export class CommentsModule {}
